module.exports = __webpack_public_path__ + "img/longest-streak-white.1dde6782.svg";